import { LAST_FRAME_TTL_MS } from '../lastFrame';
import { feedKey } from '../../lib/feedContext';

/** Кадр в sessionStorage старше TTL: плашка, не тихая лента. */
export function lastFrameStale(now = Date.now()): boolean {
  try {
    const raw = sessionStorage.getItem(feedKey('forq.feed.last'));
    if (raw === null || raw === '') return false;
    const data = JSON.parse(raw) as { at?: number };
    return typeof data.at === 'number' && now - data.at > LAST_FRAME_TTL_MS;
  } catch {
    return false;
  }
}
